import React from 'react';
import { CircularProgress } from '@mui/material';

import { useTranslation } from 'react-i18next';

const LoadingNew = () => {
  const { t } = useTranslation('maastotaulukot');

  return (
    <div className={'loading is-active'}>
      <span className="loading-icon">
        <CircularProgress />
      </span>
      <p className="loading-text">{t('app.loading')}</p>
    </div>
  );
};

export default LoadingNew;
